import React, { useState, useEffect, useRef } from 'react';

// styles imports
import '../css/IndexCarrusel.css';

// ==========================================
// CONFIGURACIÓN DE TIEMPO (en milisegundos)
// ==========================================
const INTERVAL_MS = 1000;

// Lista de tus fotos ubicadas en src/img/CaruselPictures/
const photoNames = [
  'Inicio 01.jpg', 'Inicio 02.jpg', 'Inicio 03.jpg', 'Inicio 04.jpg',
  'Inicio 05.jpg', 'Inicio 06.jpg', 'Inicio 07.jpg', 'Inicio 08.jpg',
  'Inicio 09.jpg', 'Inicio 10.jpg', 'Inicio 11.jpg', 'Inicio 12.jpg',
  'Inicio 13.jpg', 'Inicio 14.jpg', 'Inicio 15.jpg', 'Inicio 16.jpg',
  'Inicio 17.jpg',
];

// Carga estática de imágenes mediante require
const imageList = photoNames.map((name) => {
  try {
    const img = require(`../img/CaruselPictures/${name}`);
    return img && img.default ? img.default : img;
  } catch (err) {
    console.error(`No se pudo cargar la imagen: ${name}`, err);
    return null;
  }
}).filter(Boolean);

function IndexCarrusel() {
  // Inicializamos directamente con la imagen 0 a la izquierda y la 1 a la derecha
  const [leftImage, setLeftImage] = useState(imageList[0] || '');
  const [rightImage, setRightImage] = useState(imageList[1] || imageList[0] || '');

  // Usamos una referencia para llevar el control secuencial
  const nextIndex = useRef(2);

  // Toma la siguiente imagen en orden y avanza el índice 1 posición
  const getNextSequentialImage = () => {
    if (imageList.length === 0) return '';
    const img = imageList[nextIndex.current % imageList.length];
    nextIndex.current = (nextIndex.current + 1) % imageList.length;
    return img;
  };

  useEffect(() => {
    if (imageList.length === 0) return;

    // 1. Intervalo para el cuadro izquierdo
    const leftInterval = setInterval(() => {
      setLeftImage(getNextSequentialImage());
    }, INTERVAL_MS);

    // 2. Desfase de medio intervalo
    const delay = INTERVAL_MS / 2;
    let rightInterval;

    const timeout = setTimeout(() => {
      // Primer cambio con retraso para el cuadro derecho
      setRightImage(getNextSequentialImage());

      // Intervalo continuo para el cuadro derecho
      rightInterval = setInterval(() => {
        setRightImage(getNextSequentialImage());
      }, INTERVAL_MS);
    }, delay);

    return () => {
      clearInterval(leftInterval);
      clearTimeout(timeout);
      if (rightInterval) clearInterval(rightInterval);
    };
  }, []); 

  return (
    <div style={{ width: '100%' }}>
      <div
        className="page__hero"
        style={{
          display: 'flex',
          width: '100%',
          gap: '8px',
          zIndex: '1'
        }}
      >
        {/* Cuadro Izquierdo */}
        <section
          className="carusel"
          style={{
            flex: 1,
            aspectRatio: '1 / 1',
            position: 'relative', // Necesario para superponer las imágenes
            overflow: 'hidden'
          }}
        >
          {imageList.map((img) => (
            <div
              key={img}
              style={{
                position: 'absolute',
                top: 0, 
                left: 0, 
                width: '100%', 
                height: '100%',
                backgroundImage: `url("${img}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                opacity: leftImage === img ? 1 : 0,
                zIndex: leftImage === img ? 1 : 0 // Mantiene la imagen activa por encima
              }}
            />
          ))}
        </section>

        {/* Cuadro Derecho */}
        <section
          className="carusel directory_wrapper"
          style={{
            flex: 1,
            aspectRatio: '1 / 1',
            position: 'relative',
            overflow: 'hidden'
          }}
        >
          {imageList.map((img) => (
            <div
              key={img}
              style={{
                position: 'absolute',
                top: 0, 
                left: 0, 
                width: '100%', 
                height: '100%',
                backgroundImage: `url("${img}")`,
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                backgroundRepeat: 'no-repeat',
                opacity: rightImage === img ? 1 : 0,
                zIndex: rightImage === img ? 1 : 0
              }}
            />
          ))}
        </section>
      </div>
    </div>
  );
}

export default IndexCarrusel;